// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Object Definition
export class WorkspaceProfile {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        this.name = model.name;
        this.color = model.color;
        this.avatar = (_a = model.avatar) !== null && _a !== void 0 ? _a : null;
        this.handle = model.handle;
        this.billingDetails = model.billingDetails
            ? {
                address: model.billingDetails.address
                    ? {
                        postal: (_b = model.billingDetails.address.postal) !== null && _b !== void 0 ? _b : null,
                        street1: (_c = model.billingDetails.address.street1) !== null && _c !== void 0 ? _c : null,
                        street2: (_d = model.billingDetails.address.street2) !== null && _d !== void 0 ? _d : null,
                        city: (_e = model.billingDetails.address.city) !== null && _e !== void 0 ? _e : null,
                        country: (_f = model.billingDetails.address.country) !== null && _f !== void 0 ? _f : null,
                        state: (_g = model.billingDetails.address.state) !== null && _g !== void 0 ? _g : null,
                    }
                    : null,
                email: (_h = model.billingDetails.email) !== null && _h !== void 0 ? _h : null,
                companyName: (_j = model.billingDetails.companyName) !== null && _j !== void 0 ? _j : null,
                companyId: (_k = model.billingDetails.companyId) !== null && _k !== void 0 ? _k : null,
                notes: (_l = model.billingDetails.notes) !== null && _l !== void 0 ? _l : null,
                vat: (_m = model.billingDetails.vat) !== null && _m !== void 0 ? _m : null,
                poNumber: (_o = model.billingDetails.poNumber) !== null && _o !== void 0 ? _o : null,
            }
            : null;
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Serialization & Deserialization
    /** Constructs directly manipulable update object for workspace profile */
    toProfileUpdateObject() {
        return {
            name: this.name,
            color: this.color,
        };
    }
    /** Constructs representation that can be used to write full object to remote */
    toRemote() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
        return {
            name: this.name,
            color: this.color,
            avatar: (_a = this.avatar) !== null && _a !== void 0 ? _a : undefined,
            handle: this.handle,
            billingDetails: {
                address: ((_b = this.billingDetails) === null || _b === void 0 ? void 0 : _b.address)
                    ? {
                        postal: (_d = (_c = this.billingDetails) === null || _c === void 0 ? void 0 : _c.address.postal) !== null && _d !== void 0 ? _d : undefined,
                        street1: (_f = (_e = this.billingDetails) === null || _e === void 0 ? void 0 : _e.address.street1) !== null && _f !== void 0 ? _f : undefined,
                        street2: (_h = (_g = this.billingDetails) === null || _g === void 0 ? void 0 : _g.address.street2) !== null && _h !== void 0 ? _h : undefined,
                        city: (_k = (_j = this.billingDetails) === null || _j === void 0 ? void 0 : _j.address.city) !== null && _k !== void 0 ? _k : undefined,
                        country: (_m = (_l = this.billingDetails) === null || _l === void 0 ? void 0 : _l.address.country) !== null && _m !== void 0 ? _m : undefined,
                        state: (_p = (_o = this.billingDetails) === null || _o === void 0 ? void 0 : _o.address.state) !== null && _p !== void 0 ? _p : undefined,
                    }
                    : undefined,
                email: (_r = (_q = this.billingDetails) === null || _q === void 0 ? void 0 : _q.email) !== null && _r !== void 0 ? _r : undefined,
                companyName: (_t = (_s = this.billingDetails) === null || _s === void 0 ? void 0 : _s.companyName) !== null && _t !== void 0 ? _t : undefined,
                companyId: (_v = (_u = this.billingDetails) === null || _u === void 0 ? void 0 : _u.companyId) !== null && _v !== void 0 ? _v : undefined,
                notes: (_x = (_w = this.billingDetails) === null || _w === void 0 ? void 0 : _w.notes) !== null && _x !== void 0 ? _x : undefined,
                vat: (_z = (_y = this.billingDetails) === null || _y === void 0 ? void 0 : _y.vat) !== null && _z !== void 0 ? _z : undefined,
                poNumber: (_1 = (_0 = this.billingDetails) === null || _0 === void 0 ? void 0 : _0.poNumber) !== null && _1 !== void 0 ? _1 : undefined,
            },
        };
    }
    /** Constructs representation that can be used to transport the instantiated object as JSON, for example for SSR <> Client use-cases. Reconstruct to class instance using fromTransport */
    toTransport() {
        return this.toRemote();
    }
    /** Reconstructs class from the transport model */
    static fromTransport(model) {
        return new WorkspaceProfile(model);
    }
}
